<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>供应商</label>
          <el-select v-model="supplierId" placeholder="Select" class="select-item" filterable>
            <el-option v-for="item in supplierIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <label>品牌</label>
          <el-select v-model="brandId" placeholder="Select" class="select-item" filterable>
            <el-option v-for="item in brandIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <commodity-type-list @confirm="getCommodityType($event)" :reSet="reSet" />
        </div>
        <div class="dialog-input-item">
          <label>商品名称</label>
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        v-loading="listLoading"
        @selection-change="selsChange"
        @header-click="selsAll"
        @cell-click="toggleSelection"
        size="default"
        style="width: 100%"
        height="480"
        border
    >
      <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
      <el-table-column property="updateTime" label="入库时间" width="84"/>
      <el-table-column property="shopName" label="所属门店" width="84"/>
<!--      <el-table-column property="" label="入库货单" width="106" class-name="cursor">-->
<!--        <template #default="scope">-->
<!--          <el-image class="item-img" fit="cover" :src="scope.row.waybillSmallImg" @click="showImg(scope.row.waybillImg)">-->
<!--            <template #error>-->
<!--              <div class="el-img-error">暂无图片</div>-->
<!--            </template>-->
<!--          </el-image>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column property="numberNo" label="关联批次号" width="96"/>-->
      <el-table-column property="supplierName" label="供应商"  width="84"/>
      <el-table-column property="brandName" label="品牌"  width="84"/>
      <el-table-column property="commodityName" label="商品名称"/>
      <el-table-column property="" label="商品图片" width="90">
        <template #default="scope">
          <div v-if="scope.row.commodityImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
            <el-image class="item-img" fit="cover" :src="scope.row.commodityImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
          <div v-else>
            <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="commodityTypeName" label="商品分类"  width="84">
        <template #default="scope">
          {{scope.row.commodityTypePreName?scope.row.commodityTypePreName + '/':''}}{{scope.row.commodityTypeName}}
        </template>
      </el-table-column>
      <el-table-column property="specification" label="商品规格"  width="84"/>
      <el-table-column property="price" label="进货单价"  width="84"/>
      <el-table-column property="retailPrice" label="建议零售价" width="96"/>
      <el-table-column property="num" label="采购数量"  width="84"/>
      <el-table-column property="giveNum" label="赠送数量"  width="84"/>
      <el-table-column property="num" label="入库数量"  width="84">
        <template #default="scope">
          {{ scope.row.num + scope.row.giveNum }}
        </template>
      </el-table-column>
      <el-table-column property="reduceMoney" label="优惠金额"  width="84"/>
      <el-table-column property="" label="入库总计"  width="84">
        <template #default="scope">
<!--          {{ Number(scope.row.num)*Number(scope.row.price) }}-->
          {{scope.row.stockSum}}
        </template>
      </el-table-column>
      <el-table-column property="" label="状态">
        <template #default="scope">
          <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待提交':scope.row.state == 1?'待入库':scope.row.state == 2?'已驳回':scope.row.state == 3?'已入库':'' }}</p>
        </template>
      </el-table-column>
      <!--            <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"/>-->
<!--      <el-table-column label="操作" width="90">-->
<!--        <template #default="scope">-->
<!--          <el-space wrap>-->
<!--          </el-space>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <!--分页-->
<!--    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">-->
<!--    </el-pagination>-->
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import {getFormData, postFormData} from '@/api/api';
import {listAllBrand, listAllSupplier, listPlanPurchaseCommodity} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
import ImgViewer from "@/assets/js/imageViewer";
import PutStorageDialog from "@/views/commodity/components/PutStorageDialog";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import {mul, Number_SubAll} from "@/assets/shared/util";
import commodityTypeList from "@/components/commodityTypeList";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents, commodityTypeList},
  data() {
    return {
      // userForm: this.value.userForm,
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      supplierIdArray: [],
      supplierId: 0,

      brandIdArray: [],
      brandId: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //搜索
      searchTypeList: [
        {label : '商品名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      // shopIdArray: [
      //   {name: '不限', id: 0}
      // ],
      // shopIdArr:[],
      shopId: this.value.shopId,
      purchaseList: this.value.purchaseList,
      limitState: false,

      idArray: [],

      commodityTypeId: 0,
      commoditySubTypeId: 0,
      reSet: false

      // visibleShopList: JSON.parse(sessionStorage.getItem('visibleShopList')),
    }
  },
  methods: {

    getCommodityType(e) {
      console.log(e)
      this.commodityTypeId = e[0]
      this.commoditySubTypeId = e[1]
      this.reSet = e[2]
    },

    cancel() {
      this.$emit("close");
    },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.commodityId,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    getSupplierList() {
      getFormData(listAllSupplier).then(data=> {
        this.supplierIdArray = [
          {name: '不限', id: 0}
        ]
        this.supplierIdArray = this.supplierIdArray.concat(data.data)
      })
    },

    getBrandList() {
      getFormData(listAllBrand).then(data=> {
        this.brandIdArray = [
          {name: '不限', id: 0}
        ]
        this.brandIdArray = this.brandIdArray.concat(data.data)
      })
    },


    getPage() {
      this.listLoading = true;
      this.searchLoading = true;
      let param = {};
      param['shopId'] = this.shopId;
      param['supplierId'] = this.supplierId;
      param['brandId'] = this.brandId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      param['commodityTypeId'] = this.commoditySubTypeId>0?this.commoditySubTypeId:this.commodityTypeId;
      getFormData(listPlanPurchaseCommodity, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.pageDataList = data['data'];
          this.pageDataList.map(item => {
            item.stockSum = Number_SubAll(mul(Number(item.num), Number(item.price)), item.reduceMoney)
          })
          for(let i=0; i<this.purchaseList.length; i++) {
            for(let j=0; j<this.pageDataList.length; j++) {
              if(this.purchaseList[i].id == this.pageDataList[j].id) {
                this.pageDataList.splice(j, 1)
              }
            }
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    summit() {
      let arr = []
      this.pageDataList.map(item => {
        if(this.idArray.indexOf(item.id) > -1) {
          arr.push(item)
        }
      })
      this.$emit('confirm', arr)
    }



  },
  mounted() {
    this.getSupplierList()
    this.getBrandList()
    this.getPage();
  }
}
</script>

<style>
.item-img {
  width: 64px;
  height: 64px;
}

</style>
